import { render, staticRenderFns } from "./StepChoice.vue?vue&type=template&id=76df56a9"
import script from "./StepChoice.vue?vue&type=script&lang=js"
export * from "./StepChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports